interface StatProps {
	stat: string | [string, string] | [boolean, string];
	display: string;
	update: (newVal: string | [string, string] | [boolean, string]) => void
	width?: string;
	default?: string;
}

export function Stat(props: React.ComponentPropsWithRef<"div"> & StatProps) {
	return <div className="flex flex-row p-1 gap-2">
		{typeof props.stat === "string" ?
			<>
				<label>{props.display}</label>
				<input type="text" className="border-b-1 w-1/3" style={{ width: props.width ? `${props.width}px` : 'initial' }} placeholder={props.default} defaultValue={props.stat || null} onBlur={e => props.update(e.target.value)} />
			</>
			: typeof props.stat[0] === "string" ?
				<>
					<label>{props.display}</label>
					<input type="text" className="border-b-1 w-1/3" style={{ width: props.width ? `${props.width}px` : 'initial' }} placeholder={props.default} defaultValue={props.stat[0] || null} onBlur={e => props.update([e.target.value, props.stat[1]])} />
					<div className="border-r-2 border-r-red-500 m-0"></div>
					<input type="text" className="border-b-1 w-1/3 m-p" style={{ width: props.width ? `${props.width}px` : 'initial' }} placeholder={props.default} defaultValue={props.stat[1] || null} onBlur={e => props.update([props.stat[0], e.target.value])} />
				</>
				: typeof props.stat[0] === "boolean" ?
					<>
						<input type="checkbox" className="border" defaultChecked={props.stat[0]} onBlur={e => props.update([e.target.checked, props.stat[1]])} />
						<label>{props.display}</label>
						<input type="text" className="border-b-1 w-1/3" style={{ width: props.width ? `${props.width}px` : 'initial' }} placeholder={props.default} defaultValue={props.stat[1] || null} onBlur={e => props.update([props.stat[0], e.target.value])} />
					</>
					: ''
		}
	</div >;

}
